/* eslint-disable @angular-eslint/no-output-native */
/* eslint-disable @angular-eslint/no-input-rename */
/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */

import { Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { AppContextService } from '../core/services';
import * as moment from 'moment';
import { FormatHelper } from '../helpers';

@Component({
  selector: 'button[delay-click]',
  template: `
    <div *ngIf="delayed && tooltip && !matTooltip" class="tooltip" [matTooltip]="tooltip" [matTooltipShowDelay]="300"></div>
    <mdb-icon *ngIf="delayed" far icon="hourglass" class="mr-2"></mdb-icon>
    <ng-content></ng-content>
  `,
  providers: [MatTooltip],
  styles: [`
    :host.waiting {
      position: relative;
      cursor: wait !important;
    }

    .tooltip {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      opacity: 0;
    }
  `]
})
export class DelayClickDirective implements OnInit, OnChanges, OnDestroy {
  debug = false;
  // debug = true;

  @Input('delay-click')
  delay = 0; // sec

  @Input('delay-until')
  delayUntil = true;

  timerSet = false;
  timer?: NodeJS.Timeout;
  logger?: NodeJS.Timer;
  started?: Date|null;

  @Output()
  click = new EventEmitter();

  @Input('delay-tooltip')
  tooltipInput: string|boolean = '';
  tooltipDefault = 'Finish reading to the end first.';

  @HostBinding('class.disabled')
  @HostBinding('class.hoverable')
  @HostBinding('class.waiting')
  get delayed() {
    if (this.fastForward) return false;
    return this.timerSet || this.delayUntil !== true;
  }

  @Input()
  matTooltip?: string; // check whether matTooltip already exists to make sure single tooltip shown (parent has priority), otherwise they overlap

  get fastForward() {
    return this.context.data.fastForward;
  }

  get elapsed() {
    return this.started ? Math.max(0, moment().diff(this.started, 'milliseconds')) : 0;
  }

  get remaining() {
    return Math.max(0, this.delay - this.elapsed);
  }

  get tooltip() {
    return this.delayed ? this.tooltipText(this.tooltipInput) : '';
  }

  constructor(public context: AppContextService) {}

  ngOnInit(): void {
    if (this.debug) {
      this.setLogger(5000);
    }

    if (this.delay) {
      this.setTimer();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.delay) {
      this.delay = changes.delay.currentValue || 0;
      this.log(`timer new delay=${changes.delay.currentValue}`);
      this.setTimer();
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
    this.resetTimer();
    this.resetLogger();
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.delayed) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
    }
  }

  private setTimer() {
    if (this.fastForward) {
      return;
    }

    this.timerSet = true;

    const timeout = this.delay ? Math.max(0, (this.delay * 1000) - this.elapsed) : 0; // ms

    this.timer = setTimeout(() => this.stopTimer(), timeout);
    this.started = this.started || new Date();

    if (this.debug) {
      this.log(`timer set=${(timeout / 1000).toFixed(0)}`);
      this.setLogger(5000);
    }
  }

  private setLogger(interval: number) {
    const logging = () => {
      const state = FormatHelper.serializeObject({
        elapsed:    (this.elapsed   / 1000).toFixed(0),
        remaining:  (this.remaining / 1000).toFixed(0),
        delayed:    this.delayed,
        delay:      this.delay > 0 ? this.delay.toFixed(0) : this.delay,
        delayUntil: this.delayUntil,
        timerSet:   this.timerSet,
      });
      this.log(`timer ${state}`);
    };

    this.resetLogger();
    this.logger = setInterval(logging, interval);
  }

  private resetTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      delete this.timer;
    }
  }

  private resetLogger() {
    if (this.logger) {
      clearInterval(this.logger);
      delete this.logger;
    }
  }

  private stopTimer() {
    this.resetTimer();
    // this.resetLogger();

    this.timerSet = false;

    if (this.debug) {
      this.log('timer reset');
    }
  }

  private tooltipText(value: string|boolean) {
    return value === true ? this.tooltipDefault : value || '';
  }

  private log(msg: string) {
    if (this.debug) {
      console.log(msg);
    }
  }
}
